module.exports = __webpack_public_path__ + "static/StudioPilates-e8027fae674a101145d07752c60d7f08.png";